export default "__VITE_ASSET__D804slQT__"